import { omit } from './omit.js';
import { createElement } from 'react';

function filterProps(filter) {
  return Component => {
    return function Wrapper(props) {
      return /*#__PURE__*/createElement(Component, omit(props, filter));
    };
  };
}

export { filterProps };
